import { configureModelCore } from '@model-core/core/config';
import dayjs from '@/lib/dayjs';

export function bootstrapModelCore() {
  configureModelCore({ dateParser: (value) => dayjs(value as string) });
}
